//@ts-check
const query_base = require("./query_base");

const query = query_base();

module.exports = query;
